var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.018 4.167a3.5 3.5 0 0 1 6.435 1.255l-.39-.312a.5.5 0 1 0-.625.78l1.25 1a.5.5 0 0 0 .624 0l1.25-1a.5.5 0 0 0-.624-.78l-.467.373a4.5 4.5 0 0 0-8.304-1.84.5.5 0 0 0 .85.524m-.08 2.723-.39-.312a3.5 3.5 0 0 0 6.346 1.39.5.5 0 1 1 .827.564A4.5 4.5 0 0 1 1.53 6.517l-.468.373a.5.5 0 1 1-.624-.78l1.25-1a.5.5 0 0 1 .624 0l1.25 1a.5.5 0 1 1-.624.78",
    clipRule: "evenodd"
  })));
});
const SvgReloadsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReloadsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjAxNzkxIDQuMTY2NzFDMy42MzQ4NyAzLjE2NTU2IDQuNzM5OTMgMi41IDYuMDAwMDIgMi41QzcuNzM2IDIuNSA5LjE3Njc5IDMuNzYzODYgOS40NTI0NSA1LjQyMTY0TDkuMDYyMzcgNS4xMDk1N0M4Ljg0Njc0IDQuOTM3MDYgOC41MzIwOSA0Ljk3MjAyIDguMzU5NTggNS4xODc2NUM4LjE4NzA4IDUuNDAzMjggOC4yMjIwNCA1LjcxNzkzIDguNDM3NjcgNS44OTA0M0w5LjY4NzY3IDYuODkwNDNDOS44NzAyOCA3LjAzNjUyIDEwLjEyOTggNy4wMzY1MiAxMC4zMTI0IDYuODkwNDNMMTEuNTYyNCA1Ljg5MDQzQzExLjc3OCA1LjcxNzkzIDExLjgxMyA1LjQwMzI4IDExLjY0MDUgNS4xODc2NUMxMS40Njc5IDQuOTcyMDIgMTEuMTUzMyA0LjkzNzA2IDEwLjkzNzcgNS4xMDk1N0wxMC40NzA3IDUuNDgzMTdDMTAuMjE0MyAzLjI0MTMxIDguMzEwNTIgMS41IDYuMDAwMDIgMS41QzQuMzc4NjEgMS41IDIuOTU3OTkgMi4zNTc4NiAyLjE2NjU4IDMuNjQyMDdDMi4wMjE3MSAzLjg3NzE2IDIuMDk0ODQgNC4xODUxOCAyLjMyOTkzIDQuMzMwMDZDMi41NjUwMSA0LjQ3NDkzIDIuODczMDMgNC40MDE4IDMuMDE3OTEgNC4xNjY3MVpNMi45Mzc2NyA2Ljg5MDQzTDIuNTQ3NTggNi41NzgzNkMyLjgyMzI0IDguMjM2MTQgNC4yNjQwMyA5LjUgNi4wMDAwMiA5LjVDNy4yMDI1MiA5LjUgOC4yNjM2MyA4Ljg5NDAyIDguODk0NDcgNy45Njg0N0M5LjA1IDcuNzQwMjkgOS4zNjEwNSA3LjY4MTM5IDkuNTg5MjMgNy44MzY5MkM5LjgxNzQxIDcuOTkyNDQgOS44NzYzMSA4LjMwMzUgOS43MjA3OCA4LjUzMTY4QzguOTExNjQgOS43MTg4MiA3LjU0NzEzIDEwLjUgNi4wMDAwMiAxMC41QzMuNjg5NTIgMTAuNSAxLjc4NTcyIDguNzU4NyAxLjUyOTM3IDYuNTE2ODNMMS4wNjIzNyA2Ljg5MDQzQzAuODQ2NzM1IDcuMDYyOTQgMC41MzIwODkgNy4wMjc5OCAwLjM1OTU4NCA2LjgxMjM1QzAuMTg3MDc5IDYuNTk2NzIgMC4yMjIwNCA2LjI4MjA3IDAuNDM3NjcxIDYuMTA5NTdMMS42ODc2NyA1LjEwOTU3QzEuODcwMjggNC45NjM0OCAyLjEyOTc2IDQuOTYzNDggMi4zMTIzNyA1LjEwOTU3TDMuNTYyMzcgNi4xMDk1N0MzLjc3OCA2LjI4MjA3IDMuODEyOTYgNi41OTY3MiAzLjY0MDQ1IDYuODEyMzVDMy40Njc5NSA3LjAyNzk4IDMuMTUzMyA3LjA2Mjk0IDIuOTM3NjcgNi44OTA0M1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";